import { useEffect, useState } from "react";
import "./css/result.css"

const Result = () => {
    const url = process.env.REACT_APP_SERVER_URL
    const [message, SetMessage] = useState("")
    const [showResult, SetShowResult] = useState(true)
    const [result, setResult] = useState([])
    const [showView, setShowView] = useState(false)

    const [duration, setDuration] = useState("");
    const [startDate, setStartDate] = useState("");
    const [startTime, setStartTime] = useState("");

    const [endDate, setEndDate] = useState("");
    const [endTime, setEndTime] = useState("");

    const [exam, setExam] = useState("");
    const [examCode, setExamCode] = useState("");

    const [itemMark, setItemMark] = useState("");
    const [negativeMark, setNegativeMark] = useState("");

    const [paper, setPaper] = useState("");
    const [rightQuestion, setRightQuestion] = useState("");
    const [totalQuestion, setTotalQuestion] = useState("");

    const [type, setType] = useState("");

    const [wrongQuestion, setWrongQuestion] = useState("");

    const [item, setItem] = useState([])

    useEffect(() => {
        const data = {
            name: localStorage.getItem("name"),
            email: localStorage.getItem("email"),
            status: localStorage.getItem("status"),
            token: localStorage.getItem("token"),
            user_id: localStorage.getItem("user_id")
        }
        fetch(process.env.REACT_APP_SERVER_URL + "/api/result", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${data.token}`
            },
            body: JSON.stringify(data)
        })
            .then(response => response.json())
            .then(result => {
                if (result.status === true) {
                    setResult(result.responce)
                    SetShowResult(true)
                }
                if (result.status === false) {
                    SetMessage(result.message)
                    SetShowResult(false)
                }
            })
            .catch(err => console.error(err));
    }, []);

    const getTimeInterval = (startDate, startTime, endDate, endTime) => {
        const start = new Date(`${startDate.split(" ").reverse().join("-")} ${startTime}`);
        const end = new Date(`${endDate.split(" ").reverse().join("-")} ${endTime}`);

        let diff = end - start;
        if (diff < 0) return "00:00:00";

        const hours = Math.floor(diff / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((diff % (1000 * 60)) / 1000);

        return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    };

    const formatTime = (t) => {
        if (!t) return "";
        const [time, ampm] = t.split(" ");
        const [h, m] = time.split(":");
        return `${h}:${m} ${ampm}`;
    };

    const viwe = (item) => {
        setShowView(!showView)

        setDuration(item.duration)
        setStartDate(item.startDate)
        setStartTime(item.startTime)

        setEndDate(item.endDate)
        setEndTime(item.endTime)

        setExam(item.exam)
        setExamCode(item.examCode)

        setItemMark(item.itemMark)
        setNegativeMark(item.negativeMark)

        setPaper(item.paper)
        setRightQuestion(item.rightQuestion)
        setTotalQuestion(item.totalQuestion)

        setType(item.type)

        setWrongQuestion(item.wrongQuestion)
        setItem(item)
    }

    const viewPaper = async (item) => {
        const data = {
            name: localStorage.getItem("name"),
            email: localStorage.getItem("email"),
            token: localStorage.getItem("token"),
            status: localStorage.getItem("status"),
            user_id: localStorage.getItem("user_id"),
            userTestId: item.userTestId,
            testcode: item.testcode,
            examid: item.examid,
            paperid: item.paperid,
            type: item.type

        }
        const responce = await fetch(`${url}/api/answerkey`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${localStorage.getItem("token")}`,
            },
            body: JSON.stringify(data),
        })
        const result = await responce.json()
        if (result.status === false) {
            alert(result.message)
        }
        if (result.status === true) {
            setShowView(!showView)
            sessionStorage.setItem("data", JSON.stringify(result))
            window.open("/answersheet", "_blank");
        }
    }

    return (
        <div className="resultPageWrapper">
            {!showResult && (
                <div className="resultEmptyContainer">
                    <div className="resultEmptyBox">
                        <i className="fa-regular fa-folder-open emptyIcon"></i>
                        <h3>No Results Found</h3>
                        <p>{message} You haven’t taken any tests yet, so no results are available.</p>
                    </div>
                </div>
            )}

            {showResult && (
                <div className="resultContentContainer">
                    <div className="resultHeader">
                        <h2>Test Results</h2>
                        <p>View your past performance and analyze your scores.</p>
                    </div>

                    <div className="resultTableWrapper">
                        <table className="modernTable">
                            <thead>
                                <tr>
                                    <th>Index</th>
                                    <th className="hideOnMobile">Exam</th>
                                    <th className="hideOnMobile">Paper</th>
                                    <th className="hideOnMobile">Type</th>
                                    <th>Exam Code</th>
                                    <th className="hideOnTablet">Date</th>
                                    <th className="hideOnTablet">Marks</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {result.map((item, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td className="hideOnMobile">{item.exam}</td>
                                        <td className="hideOnMobile">{item.paper}</td>
                                        <td className="hideOnMobile">
                                            <span className="typeBadge">{item.type}</span>
                                        </td>
                                        <td className="fontMedium">{item.examCode}</td>
                                        <td className="hideOnTablet textMuted">
                                            {item.startDate + " - " + item.startTime.split(":").slice(0, 2).join(":") + " " + item.startTime.split(" ")[1]}
                                        </td>
                                        <td className="hideOnTablet fontBold textPrimary">
                                            {((item.rightQuestion * item.itemMark) - (item.wrongQuestion * item.negativeMark)).toFixed(2)}
                                        </td>
                                        <td>
                                            <button className="viewBtn" onClick={() => viwe(item)}>
                                                <i className="fa-regular fa-eye"></i> View
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}

            {/* Result Details Modal */}
            {showView && (
                <div className="resultModalOverlay">
                    <div className="resultModalBox">
                        
                        <div className="modalHeader">
                            <div>
                                <h3>Result Summary</h3>
                                <p>{exam} / {paper}</p>
                            </div>
                            <button className="closeModalBtn" onClick={() => setShowView(!showView)}>
                                <i className="fa-solid fa-xmark"></i>
                            </button>
                        </div>

                        <div className="modalBody">
                            <div className="statsGrid">
                                <div className="statItem">
                                    <span className="statLabel">Type</span>
                                    <span className="statValue">{type}</span>
                                </div>
                                <div className="statItem">
                                    <span className="statLabel">Exam Code</span>
                                    <span className="statValue">{examCode}</span>
                                </div>
                                <div className="statItem">
                                    <span className="statLabel">Date</span>
                                    <span className="statValue">{startDate.replace(/ /g, "/")}</span>
                                </div>
                                <div className="statItem">
                                    <span className="statLabel">Start Time</span>
                                    <span className="statValue">{formatTime(startTime)}</span>
                                </div>
                                <div className="statItem">
                                    <span className="statLabel">Total Duration</span>
                                    <span className="statValue">{duration}</span>
                                </div>
                                <div className="statItem">
                                    <span className="statLabel">Time Taken</span>
                                    <span className="statValue">{getTimeInterval(startDate, startTime, endDate, endTime)}</span>
                                </div>
                            </div>

                            <div className="scoreGrid">
                                <div className="scoreBox neutral">
                                    <h4>Total Questions</h4>
                                    <span>{totalQuestion}</span>
                                </div>
                                <div className="scoreBox neutral">
                                    <h4>Attempted</h4>
                                    <span>{(Number(rightQuestion) + Number(wrongQuestion))}</span>
                                </div>
                                <div className="scoreBox neutral">
                                    <h4>Remained</h4>
                                    <span>{Number(totalQuestion) - (Number(rightQuestion) + Number(wrongQuestion))}</span>
                                </div>
                                
                                <div className="scoreBox success">
                                    <h4>Right</h4>
                                    <span>{rightQuestion}</span>
                                </div>
                                <div className="scoreBox danger">
                                    <h4>Wrong</h4>
                                    <span>{wrongQuestion}</span>
                                </div>
                                <div className="scoreBox primary mainScore">
                                    <h4>Marks Obtained</h4>
                                    <span>{((rightQuestion * itemMark) - (wrongQuestion * negativeMark)).toFixed(2)}</span>
                                </div>
                            </div>
                        </div>

                        <div className="modalFooter">
                            <button className="primaryBtn" onClick={() => viewPaper(item)}>
                                <i className="fa-regular fa-file-lines"></i> View Paper
                            </button>
                            <button className="secondaryBtn" onClick={() => setShowView(!showView)}>
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Result;